import StatementQualityReport from "../components/ui/report-statement-quality.js";
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";



export default function StatementQualityReportPage() {
  return (
    <CaseDatabaseCheck>
    <CurrentCaseRequired>
      <StatementQualityReport />
    </CurrentCaseRequired>
    </CaseDatabaseCheck>
  );
}